import { createApp } from "vue";
import vant from "./plugins/Vant";
import { Toast } from "vant";
import "./styles/main.sass"; // 全局样式
import "animate.css"; // css动画库
import App from "./App.vue";
import store from "./store";
import router from "./router.js";
import directives from "./directives";
import lodash from "lodash";
import * as echarts from "echarts";
import VueWechatTitle from "vue-wechat-title";
// 设置Toast-loading默认设置
Toast.setDefaultOptions("loading", {
  forbidClick: true,
  duration: 0
});
const AppBase = createApp(App);
AppBase.config.globalProperties.lodash = lodash;
AppBase.config.globalProperties.echarts = echarts;
AppBase.config.globalProperties.$toast = Toast;
AppBase.use(store)
  .use(router)
  .use(directives)
  .use(vant)
  .use(VueWechatTitle)
  .mount("#app");
